import {Component, OnInit} from '@angular/core';
import moment from "moment/moment";
import {PrestazioneService} from "../services/prestazione.service";
import {ActivatedRoute} from "@angular/router";
import {ScrollPositionService} from "../services/scroll-position.service";
import {NoteService} from "../services/note.service";
import {FormsModule, NgForm} from "@angular/forms";
import {of, switchMap} from "rxjs";
import {DayService} from "../services/day.service";
import Swal from 'sweetalert2';

@Component({
  selector: 'app-note',
  standalone: true,
  imports: [
    FormsModule
  ],
  templateUrl: './note.component.html',
  styleUrl: './note.component.css'
})
export class NoteComponent{

  //Inizio della giornata e fine della giornata
  day: string = moment().format('YYYY-MM-DD');
  testo: string = '';

  constructor(
    private route: ActivatedRoute,
    private noteService: NoteService, // Inietta il servizio NoteService
  private dayService: DayService // Servizio per la gestione dei giorni
) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {

      // Se è presente un parametro 'day' nella query string
      if (params.get('day')) {
        this.dayService.changeDay(params.get('day'));
        this.day = params.get('day') ?? moment().format('YYYY-MM-DD');
      }

      // Richiama la funzione index del servizio NoteService
      this.noteService.getNote(this.day).subscribe(notes => {
        this.testo = notes.note[0].testo;
      });
    });
  }


  onSave(form: NgForm) {

    this.noteService.update({day: this.day, testo: this.testo})
      .pipe(
        switchMap((response) => {
          console.log("Nota aggiornata", response);

          Swal.fire({
            icon: 'success',
            title: 'Nota aggiornata',
            timer: 1000
          });

          return of(response);
        })
      )
      .subscribe({
        error: (error) => {
          console.error("Errore nell'aggiornamento della nota", error);

          Swal.fire({
            icon: 'error',
            title: 'Ops...',
            text: "Errore nell'aggiornamento della nota",
            confirmButtonColor: '#050A30'
          });

        }
      });

  }

}
